import { http } from "./config.api.js";
// 施工安全考评
import * as API_UnitCheck from "./safetyCheck/api_cstEnterprise.js";
import * as API_ProjectCheck from "./safetyCheck/api_cstProject.js";
import * as API_GoodProject from "./safetyCheck/api_GoodProject.js";

// 项目管理
import * as API_CurtainWall from "./project/api_curtainWall.js";
import * as API_ProjectMaterials from "./project/api_projectMaterials.js";
import * as API_TProject from "./project/api_project.js";
import * as API_Danger from "./project/api_danger.js";
import * as API_PeopleLeave from "./project/api_personLeave.js";
import * as API_Lifting from "./project/api_lifting.js";
//远程视频
import * as API_Video from "./project/api_video.js";
//施工合同
import * as API_Contract from "./project/api_contract.js";
//责任主体监管信息查询平台
import * as API_Supervision from "./project/api_supervision.js";

import * as API_SecSeal from "./api_secSeal.js";
import * as API_Common from "./api_common.js";
import API_StaticFile from "./staticFile.js";

let API_CONST = {};
if (
  process.env.NODE_ENV === "development" ||
  process.env.NODE_ENV === "local"
) {
  API_CONST = {
    // 开发环境
    SupervisorURL: "http://117.27.135.10:7080", // 监管系统地址
    SupervisorSecSealURL: "http://59.57.251.152:9900/remaius_files/uploads/", //60监管系统report地址
    writURL: "http://192.168.102.139:9999/REPORT/reportJsp/showReport.jsp", //文书查看润乾地址
    // writURL: "http://192.168.102.208:8083/REPORT/reportJsp/showReport.jsp", //文书查看润乾地址(quemei)
    originalAdress:
      "http://192.168.102.140:8080/default/com.hymake.common.widget.system.login.novaLogin.flow", //原系统跳转地址
    publicShow: "http://47.96.9.68/",
    bucketName: "hymake-nova-test",
    accessKeyId: "LTAI4FzRuMrzwgTw8YVW18KX",
    accessKeySecret: "L3oJRWKQUtDI6OZ56qqGvQgU9IXqgv",
    secSuperOrg: "http://120.35.11.49:18989", //福建省建设工程质量安全监督总站
    learnUrl: "http://118.178.114.134/news", //学习园地接口
    SeerAddress: "http://192.168.102.144/", // 公示平台地址
    atmos: "http://47.96.132.2/ATMOS/rest/", //atmos对外接口地址
    // atmos:"http://192.168.102.146/atmos",//atmos对外接口地址
    // atmos:"http://59.57.251.146:24298/atmos",//atmos对外接口地址
    // 正式环境
    // SupervisorURL: "http://192.168.102.140:8080", // 监管系统地址
    // SupervisorSecSealURL: "http://192.168.102.140:8080/remaius_files/uploads/", //监管系统report地址
    // writURL: "http://118.31.77.65/REPORT/reportJsp/showReport.jsp", //文书查看润乾地址
    // originalAdress: "http://192.168.102.140:8080/default/com.hymake.common.widget.system.login.novaLogin.flow", //原系统跳转地址
    // publicShow: "http://116.62.160.139/",
    // bucketName: "hymake-nova",
    // accessKeyId: "LTAIqB4fj37MlmfS",
    // accessKeySecret: "OA5C5QKzs8a0VrlE1B6QsQZhcfKdxL",
    // secSuperOrg:"http://hms.jsqqy.com:7878",//福建省建设工程质量安全监督总站
    // atmos:"http://atmos.hmzan.com/ATMOS/rest/",//atmos对外接口地址
    // learnUrl:"http://120.55.149.143/news",//学习园地接口
    // SeerAddress: 'http://118.31.14.249:81/', // 公示平台地址
    // 登录加密key
    LOGIN_KEY: "NOVA_NKT",
  };
}
if (process.env.NODE_ENV === "ali") {
  API_CONST = {
    // 阿里测试
    SupervisorURL: "http://117.27.135.10:7080", // 监管系统地址
    SupervisorSecSealURL: "http://117.27.135.10:7080/remaius_files/uploads/", //监管系统report地址
    writURL: "http://47.96.134.2/REPORT/reportJsp/showReport.jsp", //文书查看润乾地址
    originalAdress:
      "http://117.27.135.10:7080/default/com.hymake.common.widget.system.login.novaLogin.flow", //原系统跳转地址
    publicShow: "http://47.96.9.68/",
    bucketName: "hymake-nova-test",
    accessKeyId: "LTAI4FzRuMrzwgTw8YVW18KX",
    accessKeySecret: "L3oJRWKQUtDI6OZ56qqGvQgU9IXqgv",
    secSuperOrg: "http://120.35.11.49:18989", //福建省建设工程质量安全监督总站
    atmos: "http://47.96.132.2/ATMOS/rest/", //atmos对外接口地址
    learnUrl: "http://118.178.114.134/news", //学习园地接口
    SeerAddress: "http://59.57.251.149:99/", // 公示平台地址
    // 登录加密key
    LOGIN_KEY: "NOVA_NKT",
  };
}
if (process.env.NODE_ENV === "production") {
  API_CONST = {
    // 正式环境
    SupervisorURL: "http://192.168.102.140:8080", // 监管系统地址
    SupervisorSecSealURL: "http://192.168.102.140:8080/remaius_files/uploads/", //监管系统report地址
    writURL: "http://118.31.77.65:8000/REPORT/reportJsp/showReport.jsp", //文书查看润乾地址
    originalAdress:
      "http://192.168.102.140:8080/default/com.hymake.common.widget.system.login.novaLogin.flow", //原系统跳转地址
    publicShow: "http://aurora.hmzan.com",
    bucketName: "hymake-nova",
    accessKeyId: "LTAIqB4fj37MlmfS",
    accessKeySecret: "OA5C5QKzs8a0VrlE1B6QsQZhcfKdxL",
    secSuperOrg: "http://hms.jsqqy.com:7878", //福建省建设工程质量安全监督总站
    atmos: "http://atmos.hmzan.com/rest/", //atmos对外接口地址
    learnUrl: "http://www.hmzan.com/news", //学习园地接口
    SeerAddress: "http://118.31.14.249:81/", // 公示平台地址
    // 登录加密key
    LOGIN_KEY: "NOVA_NKT",
  };
}
export { API_CONST };
// 静态文件
export { API_StaticFile };

export { API_Common }; //
export { API_SecSeal }; //签章

// 项目管理
export { API_TProject }; //项目相关
export { API_CurtainWall }; //幕墙管理
export { API_Danger }; //危险源
export { API_PeopleLeave }; //人员请假
export { API_Lifting }; //建筑起重机械管理

export { API_Video }; //远程监控
export { API_Contract }; //施工合同
export { API_Supervision }; //责任主体监管信息查询平台

// 安全考评
export { API_GoodProject }; //优良项目
export { API_UnitCheck }; //企业考评
export { API_ProjectCheck }; //项目考评

export { API_ProjectMaterials }; //主要材料



// WEBPACK FOOTER //
// ./src/api/api.js